import styled from '@emotion/styled';

export const CardWrapper = styled.div`
    margin: 4rem auto 2rem;
    display: flex;
    padding: 1.6rem;
    background-color: #ffffff;
    width: 26.6rem;
    height: 17.2rem;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 0.8rem;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.08);
    #status {
        display: flex;
        justify-content: space-between;
        span.label.boxed.green {
            height: 22px;
        }
    }
`;

export const AccountNumber = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    height: 3.2rem;
    color: #1b2830;
    font-size: 1.4rem;
    font-weight: 500;
    p {
        font-size: 1.2rem;
        margin-bottom: 0.6rem;
    }
`;

export const EditHeaderWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 62px;
    padding: 0 20px 0 16px;
    border-bottom: 1px solid #dcdfe1;
    color: #1b2830;
    cursor: pointer;

    img {
        margin-right: 4px;
        display: none;
    }

    .radio {
        display: flex;
        align-items: center;
        flex-grow: 1;
        margin-bottom: 0;

        .form-group__label-group {
            margin-bottom: 0;
        }
    }

    @media screen and (min-width: 378px) {
        img {
            display: inline;
        }
    }
`;

export const IconWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-left: 2.4rem;
`;

export const EditBodyWrapper = styled.div`
    margin: 1.6rem;
    .agree-checkbox {
        padding-top: 20px;
        border-top: 1px solid #dcdfe1;
    }
`;

export const EditWrapper = styled.div`
    border-radius: 0.4rem;
    box-shadow: 0 2px 10px 0 rgba(46, 62, 79, 0.25);
    background-color: #ffffff;
`;

export const CustomisedModalBody = styled.div`
    .flx-loading-spinner--fade-in {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        background-color: #ffffff;

        .loadingSpinner {
            margin-top: 0;
        }
    }
`;

export const EditIframe = styled.iframe`
    width: 100%;
    border: 0;
`;

export const FormWrapper = styled.form`
    padding-bottom: 1.2rem;
    margin-bottom: 2rem;
    border-bottom: 1px solid #dcdfe1;
    .form-group {
        margin-bottom: 1.6rem;
        .help-block {
            margin-bottom: 0;
        }
    }
`;
